var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 54,
    viewBox: "0 0 58 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9465_23012)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M43.9423 41.6286H13.028C12.4757 41.6286 12.028 41.1808 12.028 40.6286V18.9714C12.028 18.4191 11.5803 17.9714 11.028 17.9714H8.39941C7.84713 17.9714 7.39941 17.5237 7.39941 16.9714V12.077C7.39941 11.8957 7.44867 11.7179 7.54192 11.5625L11.7367 4.5712C11.9174 4.26999 12.2429 4.08569 12.5942 4.08569H44.9214C45.2557 4.08569 45.568 4.25279 45.7534 4.53099L50.4315 11.5481C50.541 11.7123 50.5994 11.9053 50.5994 12.1028V16.9714C50.5994 17.5237 50.1517 17.9714 49.5994 17.9714H45.9423C45.39 17.9714 44.9423 18.4191 44.9423 18.9714V40.6286C44.9423 41.1808 44.4946 41.6286 43.9423 41.6286Z",
    fill: "url(#paint0_linear_9465_23012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 44.2L5 44.1998",
    stroke: "#FF4E83",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74141 9.42582L9.64933 3.23716C10.5287 1.8445 12.0608 1 13.7079 1H44.2922C45.9393 1 47.4714 1.84453 48.3508 3.23723L52.2586 9.42585C52.7429 10.1929 53 11.0815 53 11.9886V17.8C53 19.1255 51.9255 20.2 50.6 20.2H7.4C6.07452 20.2 5 19.1255 5 17.8V11.9887C4.99999 11.0815 5.25706 10.1929 5.74141 9.42582Z",
    stroke: "#FF4E83",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62395 44.2L9.62371 20.2",
    stroke: "#FF4E83",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2001 44.2L48.1999 20.2",
    stroke: "#FF4E83",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2 44.2V20.2301",
    stroke: "#FF4E83",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7935 10.6H5.20605",
    stroke: "#FF4E83",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9465_23012",
    x: 0,
    y: 0,
    width: 58,
    height: 53.2001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9465_23012"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9465_23012",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9465_23012",
    x1: 8.53354,
    y1: 41.9984,
    x2: -0.117366,
    y2: 12.2637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00221239,
    stopColor: "#FF4E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB5A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedStore);
export default __webpack_public_path__ + "static/media/red-store.0fc1e7bd6fd23a037b51f171f8c99fa2.svg";
export { ForwardRef as ReactComponent };